import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useCurrentUserRole } from '@/hooks/use-current-user-role';

const OperatorsLayoutPage = () => {
  const role = useCurrentUserRole();

  if (role === undefined) {
    return null;
  }

  if (role === 'operator' || role === 'admin') {
    return <Outlet />;
  }

  if (role === 'provider') {
    return <Navigate to='/provider/dashboard' search={{ draftId: undefined }} />;
  }

  return <Navigate to='/substitute/dashboard' />;
};

export const Route = createFileRoute('/_protected/operators')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['common', 'operator']);
    return null;
  },
  component: OperatorsLayoutPage,
});
